import { useContext, useEffect, useState } from 'react';

import InternalAssignment from '../../Model/InternalAssignment';
import { AssignmentRole } from '../../utils/internalAssignments';
import { ChatChannelContext, ChatContext } from '../context';

const useAssigneeOptions = () => {
  const { coachDoc } = useContext(ChatChannelContext);
  const { chatUser } = useContext(ChatContext);
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const coachId = coachDoc?.id;
  const coachName = chatUser?.name;

  useEffect(() => {
    const fetchAssignees = async () => {
      if (!coachId || !coachName) return;

      try {
        const coach = { id: coachId, name: coachName, role: AssignmentRole.COACH };
        const acCollection = await InternalAssignment.getCurrentAssignmentOfCoachByRole(
          coachId,
          AssignmentRole.ASSISTANT_COACH,
        );
        const acs = acCollection.docs.map((ac) => ({
          id: ac.userId,
          name: ac.userName,
          role: AssignmentRole.ASSISTANT_COACH,
        }));
        setAssigneeOptions([coach, ...acs]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssignees();
  }, [coachId, coachName]);

  return { assigneeOptions, isLoading };
};

export default useAssigneeOptions;
